import { loadStripe } from '@stripe/stripe-js';
import { useState, useEffect } from 'react';

export default function useBilling(props) {
    const { purchasesData, resourcesData } = props;
    const [purchases, setPurchases] = useState(null);
    const [loading, setLoading] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [purchasePerPage, setPurchasePerPage] = useState(10);
    const [isDialogOpen, setDialogOpen] = useState(false);

    const [totalCredits, setTotalCredits] = useState(0);
    const [usedCredits, setUsedCredits] = useState(0);
    const [remainingCredits, setRemainingCredits] = useState(0);

    const stripePromise = loadStripe(STRIPE_PK);
    const graphicData = {
        labels: [_t.components.billing.usedCredits(), _t.components.billing.remainingCredits()],
        datasets: [
            {
                data: [usedCredits, remainingCredits],
                backgroundColor: ['#91df91', '#38a169'],
                borderWidth: 0
            }
        ]
    };
    const defaultGraphicData = {
        labels: ['No Credits'],
        datasets: [
            {
                data: [100],
                backgroundColor: ['#ddd'],
                borderWidth: 0
            }
        ]
    };

    // Get current purchases
    const indexOfLastPurchase = currentPage * purchasePerPage;
    const indexOfFirstPurchase = indexOfLastPurchase - purchasePerPage;
    const currentPurchases = purchases && purchases.slice(indexOfFirstPurchase, indexOfLastPurchase);

    // Change page
    const paginate = (pageNumber) => setCurrentPage(pageNumber);

    useEffect(() => {
        if (purchasesData) setPurchases(purchasesData);

        if (resourcesData) {
            setUsedCredits(resourcesData.usedCredits || 0);
            setTotalCredits(resourcesData.totalCredits || 0);
            setRemainingCredits(resourcesData.availableCredits || 0);
        }
    }, [purchasesData, resourcesData]);

    return {
        purchases,
        purchasePerPage,
        loading,
        currentPage,
        isDialogOpen,
        setDialogOpen,
        totalCredits,
        usedCredits,
        remainingCredits,
        stripePromise,
        graphicData,
        defaultGraphicData,
        currentPurchases,
        paginate
    };
}
